import { REQUEST_STATUS } from '../../../../constants/request'
import i18n from '../../../../i18n'

export function getRequestEditStatusModalStatusFieldLabel(option) {
  if (option.id) {
    return i18n.t(REQUEST_STATUS[option.id].text)
  }
}

export function getRequestEditStatusModalStatusFieldValue(option) {
  return option?.id
}
